import { useRef, useState } from 'react';

// Bir modalı başlığından (header) tutup sürükleyebilme özelliği. `offset`'i modalın kök elemanına
// `style={{ transform: \`translate(${offset.x}px, ${offset.y}px)\` }}` olarak uygula, dönen
// `onMouseDown`'ı başlık elemanına ver. Kapatma butonu gibi tıklanabilir alt elemanlar
// `ignoreSelector` (varsayılan '.settings-close, .sh-close') ile sürüklemeyi tetiklemekten hariç tutulur.
export default function useDraggable(ignoreSelector = '.settings-close, .sh-close') {
  const [offset, setOffset] = useState({ x: 0, y: 0 });
  const dragRef = useRef(null); // { startX, startY, baseX, baseY }

  const onMouseDown = (e) => {
    if (ignoreSelector && e.target.closest(ignoreSelector)) return;
    dragRef.current = { startX: e.clientX, startY: e.clientY, baseX: offset.x, baseY: offset.y };

    const handleMove = (ev) => {
      if (!dragRef.current) return;
      setOffset({
        x: dragRef.current.baseX + (ev.clientX - dragRef.current.startX),
        y: dragRef.current.baseY + (ev.clientY - dragRef.current.startY),
      });
    };
    const handleUp = () => {
      dragRef.current = null;
      window.removeEventListener('mousemove', handleMove);
      window.removeEventListener('mouseup', handleUp);
    };
    window.addEventListener('mousemove', handleMove);
    window.addEventListener('mouseup', handleUp);
  };

  return { offset, onMouseDown };
}
